import React from "react";

import { IconMainMenuViews } from "~/components/icon";

import { filterCustomViews } from "../../../app/state/view/ViewUtils";
import { useQueryViews } from "../../../common/use-query-views";
import { useUserProfile } from "../../../common/use-user-profile";
import { useNavigateToLink } from "../../../components/react/link";
import { VIEWS_OVERVIEW_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

import { ViewMenuItemView } from "./ViewMenuItemView";
import { ViewMenuOverviewItem } from "./ViewMenuOverviewItem";

export const ViewMenu: React.FC = () => {
	const allViews = useQueryViews((views) => filterCustomViews([...views.values()]));

	const [starredViews] = useUserProfile({
		select: (userProfile) => allViews?.filter((view) => userProfile.starredViews.has(view.id!)),
	});

	const linkToOverview = useNavigateToLink(VIEWS_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			data-trackid="lp-views"
			// assign the defaultOpen as soon as the data is available
			defaultOpen={starredViews && starredViews.length > 0}
			icon={<IconMainMenuViews className="text-grey-800" height={18} width={18} />}
			label="Views"
			to={linkToOverview}
		>
			<ViewMenuOverviewItem data-trackid="lp-starred_views" viewsCount={allViews?.length} />

			{starredViews?.length ? (
				<div className="mt-3" data-testid="lp-starred-views-list">
					{starredViews.map((view) => (
						<ViewMenuItemView key={view.id} view={view} />
					))}
				</div>
			) : null}
		</MainMenuItemLayout>
	);
};
